/**
 * MeInfo wire shape — the subset of `GET /api/me/v1/me` the frontline
 * apps drawer needs (greeting + idle ceiling). Lifted in Milestone D
 * (docs/product-areas.md).
 *
 * `display_name` is the canonical greeting source; `primary_email` is
 * the fallback. `session.idle_seconds` is the server-supplied walk-
 * away ceiling for Shared Terminal sessions — the SPA's UX timer
 * never exceeds it, and the server-side cookie TTL is the real
 * security control.
 *
 * Every field is optional because the response is permissive (some
 * surfaces may lack a display_name; sessions other than TypeTerminal
 * may not surface an idle_seconds). The Zod parse accepts this; the
 * helpers (extractGreetingName, loadFrontlineApps) handle the missing
 * values gracefully.
 */

import { z } from "zod";

export const meInfoSchema = z.object({
  display_name: z.string().optional(),
  primary_email: z.string().optional(),
  session: z
    .object({
      idle_seconds: z.number().optional(),
    })
    .optional(),
});

export type MeInfo = z.infer<typeof meInfoSchema>;
